import { importAll } from './helpers/import-all';
const stratsysProductsCache = {};
importAll(stratsysProductsCache, require.context('@stratsys/stratsysiconlib/assets/products/', true, /\.svg$/));
export default stratsysProductsCache;
